export function operation() {
  return {
    id: '',
    fulfillmentIds: [],
    orderScheduling: {}
  };
}
//# sourceMappingURL=operation.js.map